const initialState = {
  loading: true,
  submissionTemplatesById: {},
  datasetMetadataById: {},
  datasetPendingRollup: {},
  duplicatedRows: null,
}

export function Datasets(state = initialState, action) {
  switch (action.type) {
    case 'SUBMISSION_TEMPLATE_LOADED':
      return {
        ...state,
        submissionTemplatesById: {
          ...state.submissionTemplatesById,
          // TEMPLATE ISSUE REPRODUCTION LOCALLY
          // replace 'action.payload.id' below with the id of whatever the route of your local computer is. IE: /codes/create/1824 <-- use 1824
          [action.payload.id]: action.payload,
        },
        loading: false,
      }

    case 'RESET_STORE':
      return {
        ...initialState,
      }

    case 'SET_DATASET_METADATA':
      return {
        ...state,
        datasetMetadataById: { ...state.datasetMetadataById, [action.payload.id]: action.payload },
      }

    case 'SET_DATASET_PENDING_ROLLUP': {
      const { id } = action.payload
      return {
        ...state,
        datasetPendingRollup: {
          [id]: action.payload,
        },
      }
    }
    case 'SET_DATASET_DUPLICATED_ROWS':
      return {
        ...state,
        duplicatedRows: action.rows,
      }
    case 'SHOW_HIDDEN_COLUMNS': {
      const { datasetId, showHidden } = action.payload
      const originalData = state.datasetDataById[datasetId]
      const refilteredColumns = originalData.allColumns.filter(col => col.visible || showHidden)
      return {
        ...state,
        datasetDataById: {
          [datasetId]: { ...originalData, columns: refilteredColumns },
        },
      }
    }
    default:
      return state
  }
}
